import AuthPages from '@/pages/Authpages';
import { Suspense, useEffect, useState, useMemo } from 'react';
import { Routes, Route, useRouteError } from 'react-router';
import { AuthRoutes } from './AuthRoutes';
import Layout from '@/components/layouts';
import Cookies from 'js-cookie';
import { getAdminRoutes } from './AdminRoutes';
import NotFound from '@/components/notfound/NotFound';
import { accessTokenCookieName } from '@/lib/constants';
import { useAppSelector } from '@/store';
import { useLocation } from 'react-router';

export default function Routers() {
  const [isAuth, setIsAuth] = useState(false);
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated); // Get auth state from Redux
  const location = useLocation(); // Detect route changes
  useEffect(() => {
    const token = Cookies.get(accessTokenCookieName);
    setIsAuth(!!token);
  }, [isAuthenticated, location]);

  const allowedRoutes = useMemo(
    () => getAdminRoutes(),
    [isAuthenticated, location],
  );

  return (
    <Suspense>
      <Routes>
        {isAuth ? (
          <Route element={<Layout />} errorElement={<ErrorBoundary />}>
            {allowedRoutes.map((route) => (
              <Route key={route.path} {...route} />
            ))}
            <Route path="*" element={<NotFound />} />{' '}
          </Route>
        ) : (
          <Route element={<AuthPages />} errorElement={<ErrorBoundary />}>
            {AuthRoutes.map((route) => (
              <Route key={route.path} {...route} />
            ))}
          </Route>
        )}
      </Routes>
    </Suspense>
  );
}

function ErrorBoundary() {
  let error = useRouteError();
  console.error(error);
  return <div>Something went wrong. Please try again.</div>;
}
